'use client';

import React from 'react';
import Markdown from 'react-markdown';

import {
    Alert,
    Alignable,
    IconName,
    Justifiable,
    Popover,
    PopoverDirection,
    Sticker,
    Text,
    TextLevels,
    TypographyBold,
    VariantState,
    View,
} from '@bytel/trilogy-react';

export type PromoBannerProps = {
    sticker?: {
        value: string;
        tooltip?: string;
        color?: VariantState;
    };
    text: string;
};

export function PromoBanner({ sticker, text }: PromoBannerProps) {
    return (
        <Alert
            banner
            status={VariantState.INFO}
            className='alert-iconless'
            title={
                <View
                    flexable
                    justify={Justifiable.JUSTIFIED_CENTER}
                    align={Alignable.ALIGNED_CENTER}
                    className='is-flex-col-mobile gap-medium'
                >
                    {sticker &&
                        (sticker.tooltip ? (
                            <Popover
                                trigger={
                                    <Sticker
                                        small
                                        variant={sticker.color}
                                        iconName={IconName.INFOS_CIRCLE}
                                        label={sticker.value}
                                    />
                                }
                                direction={PopoverDirection.BOTTOM}
                            >
                                {sticker.tooltip}
                            </Popover>
                        ) : (
                            <Sticker small variant={sticker.color} label={sticker.value} className='is-marginless' />
                        ))}
                    <Text level={TextLevels.ONE} marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                        <Markdown
                            components={{
                                p: 'span',
                                a: (props) => <a className='link' {...props} />,
                            }}
                        >
                            {text}
                        </Markdown>
                    </Text>
                </View>
            }
        />
    );
}
